import { dataHooks } from '@wix/data-hooks'

export const wixMobileAppsDataHooks = dataHooks<{
  appItem: { key: string }
  appItemCheckbox: { key: string }
  back: {}
  skip: {}
  next: {}
  stepProgressBar: {}
  title: {}
  subtitle: {}
}>('wix-mobile-apps')
